const env = {
  environment: process.env.NODE_ENV,
  applicationMode: process.env.VUE_APP_SERVICEMODE,
  applicationCode: process.env.VUE_APP_CODE,

  authUrl: process.env.VUE_APP_AUTH_URL,
  authClientId: process.env.VUE_APP_AUTH_CLIENT_ID,
  authScope: process.env.VUE_APP_AUTH_SCOPE,

  searchUri: process.env.VUE_APP_SEARCH_URI,
  billingUri: process.env.VUE_APP_BILLING_URI,
  cardUri: process.env.VUE_APP_CARD_URI,
  financialUri: process.env.VUE_APP_FINANCIAL_URI,
  insuranceUri: process.env.VUE_APP_INSURANCE_URI,
  customerUri: process.env.VUE_APP_CUSTOMER_URI,
  operationUri: process.env.VUE_APP_OPERATION_URI,
  authUri: process.env.VUE_APP_AUTH_URI,
  changerUri: process.env.VUE_APP_CHANGER_URI,
  notifyUri: process.env.VUE_APP_NOTIFY_URI,
  miniSiteUri: process.env.VUE_APP_MINI_SITE_URI,

  statesUri: process.env.VUE_APP_STATES_API_URI,
  postalCodeUri: 'https://viacep.com.br/ws',
  oidcModule: 'oidc',
};

export { env };
